import React, { useEffect, useRef } from 'react';

import { animate } from 'framer-motion';

import './EffectCount.scss';

type EffectCountProps = {
    from?: number;
    to: number;
    delay?: number;
};

export function EffectCount({ from = 0, to, delay = 0 }: EffectCountProps) {
    const nodeRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const controls = animate(from, to, {
            duration: 1,
            delay: delay / 1000,
            type: 'spring',
            stiffness: 250,
            damping: 100,
            onUpdate(value) {
                if (nodeRef.current) {
                    nodeRef.current.textContent = Math.round(value).toLocaleString();
                }
            },
        });

        return () => controls.stop();
    }, [from, to, delay]);

    return (
        <span className="yat-artifacts__effect-count" ref={nodeRef}>
            {from}
        </span>
    );
}
